import {svgInfoTwLogo} from '../SvgCode'

export default class infoTW{
    constructor(_wrapper: HTMLElement) {
        this.templ(_wrapper);
    }

    templ(_parent: HTMLElement){

        _parent.classList.add('footer-info-tw');
        _parent.innerHTML= `
        <div class="info-inner">
            <span class="info-img">${svgInfoTwLogo}</span>
            <p class="info-text">
            本遊戲部分內容涉及暴力情節。<br>
            注意使用時間，避免沉迷遊戲，可能影響身心健康。<br>
            本遊戲部分內容或服務需另行支付其他費用。
            </p>
        </div>	
        `
    }
}